module.exports = __webpack_public_path__ + "static/media/cover_template1.3d67ef02.jpg";